import { fromJS } from 'immutable'
import {
  LEAVE_TYPE_EXPORT_REQUEST,
  LEAVE_TYPE_EXPORT_SUCCESS,
  LEAVE_TYPE_EXPORT_FAILURE,
  LEAVE_TYPE_EXPORT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case LEAVE_TYPE_EXPORT_REQUEST:
      return state
        .set('isFetching', true)
    case LEAVE_TYPE_EXPORT_SUCCESS:
      return state
        .set('url', fromJS(action.payload.url))
        .set('isFetching', false)
    case LEAVE_TYPE_EXPORT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case LEAVE_TYPE_EXPORT_RESET:
      return state
        .delete('url')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/leave-type/leave-type-export-reducer.js